export default __webpack_public_path__ + "static/media/section3_1_2.2358b9c1.png";